// extracted by mini-css-extract-plugin
module.exports = {"root":"CharacterEquipCard_root__idxMy"};